import React, { useEffect, useState } from 'react';
import Element = React.JSX.Element;

import styled from 'styled-components';
import { useApp } from '../../contexts/AppContext';
import { MainButton } from '../MainButton';

const PopupOverlay = styled.div`
  position: fixed;
  z-index: 100;
  height: 100%;

  @media (min-width: 1080px) {
    width: 1080px;
    left: 50%;
    margin: 0 auto 0 -540px;
  }

  @media (max-width: 1079px) {
    width: 100%;
  }
`;

const PopupContainer = styled.div`
  color: #fff;
  & button {
    color: black;
  }

  position: absolute;
  background: #000000ca;
  border-radius: 60px;
  border: 2px solid #d57bff;
  width: 840px;
  padding: 60px;
  transform-origin: 0 100%;
  transform: scale(var(--scale));

  bottom: 30px;
  left: 20px;
`;

const Popup = ({
  children,
  hideClose,
  close,
  onConfirm,
  height,
}: {
  children: React.ReactNode;
  hideClose?: boolean;
  close?: string | Element;
  height?: number;
  onConfirm?: () => Promise<void | boolean>;
}) => {
  const [open, setOpen] = useState(false);

  const { clearEvent } = useApp();

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleConfirm = async () => {
    let abortClose: void | boolean = false;
    if (onConfirm) {
      abortClose = await onConfirm();
    }
    if (!abortClose) handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    clearEvent();
  };

  return (
    <PopupOverlay>
      <PopupContainer>
        {children}
        {!hideClose && <MainButton onClick={handleConfirm}>{close}</MainButton>}
      </PopupContainer>
    </PopupOverlay>
  );
};

export default Popup;
